import { Button } from 'react-bootstrap'
import styled from 'styled-components'

export const StyleSearchGeneral = styled.span<{ assetFolder?: string }>`
  .custom-select:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .form-control:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .save-search-btn {
    color: red !important;
  }
  .section-name {
    min-width: 12rem;
  }
`
export const StyledHomeSectionLink = styled(Button).attrs(({ className, variant, href }) => ({
  className: `d-flex align-items-center ${className ?? ''}`.trim(),
  variant: variant ?? 'link',
  href: href ?? null
}))`
  font-size: 1.6rem;
  font-weight: 350;
  &:hover,
  &:active {
    text-decoration: none;
  }

  &:focus,
  &.focus {
    box-shadow: none;
    text-decoration: none;
  }

  color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  font-weight: bold;
  position: relative;
`
